export default __webpack_public_path__ + "static/media/anya-avatar.8f434931.jpg";